import React, { useState } from 'react'
import styled from 'styled-components'
import { Button, Tooltip } from 'antd'
import { menuBuilderGpReviewCopy as copy } from 'src/constants/menuBuilderCopy'
import {
  buildGpReviewBannerText,
  recipeNeedsGpReview,
} from 'src/utils/recipeGpReview'

const RecipeGpReviewBanner = ({ recipe, onMarkReviewed }) => {
  const [isSubmitting, setIsSubmitting] = useState(false)

  if (!recipeNeedsGpReview(recipe)) {
    return null
  }

  const bannerText = buildGpReviewBannerText(recipe, copy) || copy.changedBadge

  const handleMarkReviewed = async () => {
    if (!onMarkReviewed || isSubmitting) {
      return
    }

    setIsSubmitting(true)
    try {
      await onMarkReviewed(recipe)
    } finally {
      setIsSubmitting(false)
    }
  }

  return (
    <Banner>
      <BannerText>{bannerText}</BannerText>
      {onMarkReviewed ? (
        <Tooltip title={copy.markReviewedTooltip}>
          <Button
            type='link'
            size='small'
            loading={isSubmitting}
            onClick={handleMarkReviewed}
            style={{ padding: 0, height: 'auto' }}
          >
            {copy.markReviewedCta}
          </Button>
        </Tooltip>
      ) : null}
    </Banner>
  )
}

const Banner = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px 12px;
  margin-bottom: 16px;
  padding: 10px 12px;
  border-radius: 8px;
  background-color: #fffbe6;
  border: 1px solid #ffe58f;
`

const BannerText = styled.span`
  color: #ad6800;
  font-size: 13px;
  font-weight: 600;
`

export default RecipeGpReviewBanner
